import React from 'react';
import { Award, Target, Users, TrendingUp } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const Stats = () => {
  const { t } = useTranslation();
  
  const stats = [
    { icon: Award, label: t('stats.experience'), value: '3+' },
    { icon: Target, label: t('stats.projects'), value: '200+' },
    { icon: Users, label: t('stats.satisfaction'), value: '100+' }
  ];

  return (
    <section className="stats-section">
      <div className="stats-container">
        <div className="stats-grid">
          {stats.map((stat, index) => {
            const Icon = stat.icon;
            return (
              <div key={index} className="stat-card">
                <div className="stat-icon">
                  <Icon size={32} />
                </div>
                <div className="stat-value">{stat.value}</div>
                <div className="stat-label">{stat.label}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Stats;